import { render, staticRenderFns } from "./CategoriesManagement.vue?vue&type=template&id=2f7fc4e6&scoped=true&"
import script from "./CategoriesManagement.vue?vue&type=script&lang=js&"
export * from "./CategoriesManagement.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CategoriesManagement.vue?vue&type=style&index=1&id=2f7fc4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7fc4e6",
  null
  
)

export default component.exports